/**
 * The Shop area is one route: an order opened from the list is a dialog over
 * the still-mounted list (search, filter and scroll survive closing it), and
 * `/:restaurantId/shop/orders/:orderId` stays the direct link of the order email.
 */
export const SHOP_ROUTE_PATHS = [
  '/:restaurantId/shop/orders/:orderId',
  '/:restaurantId/shop/:section(orders|products|categories|delivery|settings|history)?',
];

/** Router state of an order opened from the list: closing goes back to that list entry. */
export type OrderLinkState = { fromOrderList?: boolean };

export const orderPath = (restaurantId: string, orderId: string) => `/${restaurantId}/shop/orders/${orderId}`;
export const orderLink = (restaurantId: string, orderId: string) => ({
  pathname: orderPath(restaurantId, orderId),
  state: { fromOrderList: true } as OrderLinkState,
});
